const T = require("react").PropTypes;

const Response = {
    Type: T.shape({
        status: T.number,
        statusText: T.string,
        url: T.string
    })
};

module.exports = Response;


// WEBPACK FOOTER //
// ./src/types/Response.js